const React = require('react')
const { useState, useEffect } = require('react')
const PropTypes = require('prop-types')
const {NetPost} = require("../../axios/index")
const axios = require("axios")

function Editor(props) {
    useEffect(()=>{
        
        this.textarea.addEventListener('paste', pasteimg)

        return ()=>{this.textarea.removeEventListener('paste', pasteimg)}
    },[])


    function pasteimg(event){
 
        var isChrome = false;
        if (event.clipboardData || event.originalEvent) {
            //某些chrome版本使用的是event.originalEvent
            var clipboardData = (event.clipboardData || event.originalEvent.clipboardData);
            if(clipboardData.items){
                // for chrome
                var  items = clipboardData.items,
                    len = items.length,
                    blob = null;
                isChrome = true;
                for (var i = 0; i < len; i++) {
                
                    if (items[i].type.indexOf("image") !== -1) {
                        //getAsFile() 此方法只是living standard firefox ie11 并不支持
                        blob = items[i].getAsFile();
                     
                        var blobUrl=URL.createObjectURL(blob);
                        var value = `![图片上传中... ${blob.lastModified}]`
                        var data={
                            target:{
                                value:value
                            }
                        }
                        upimage(blob,value)
                        props.onChange(data,true)
                    }
                }
            }
        }
     
    }


    function upimage(data,e){
        let param = new FormData()
        param.append('file', data)

        NetPost("/uploadimg",param).then(res => {
            if(res.code==0){
                var todata=`![image](/${res.img})`
                props.setupImage(e,todata)
            }
          }).catch(err => {

          })

        // NetPost("uploadimg", param)
        // .then((e)=>{
        //     console.log(e)
        // })
    }

    return (
        
            <textarea
                placeholder="文章内容"
                ref={(ref) => this.textarea = ref}
                value={props.value}
                onChange={props.onChange}
                className="writeart-textarea"
            />    
  
   
    )
}

Editor.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
}

Editor.defaultProps = {
    value: ''
}

module.exports = Editor